import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import './App.css';
import { Toaster } from '@/components/ui/sonner';
import { useCanvasContext } from './hooks/useCanvasContext';
import { TooltipProvider } from '@/components/ui/tooltip';

function App() {
  return (
    <TooltipProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </TooltipProvider>
  );
}

function AppContent() {
  const { isCanvas } = useCanvasContext();

  return (
    <>
      <div
        className={`${isCanvas ? 'h-screen overflow-hidden' : 'min-h-screen'} bg-background text-foreground`}
      >
        <AppRoutes />
      </div>
      <Toaster position="top-center" expand />
    </>
  );
}

export default App;
